export default customElements.define('w-gauge-circle', class PercentageCircle extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            styleSelector: 'c-gauge-circle',
            templateHTML: `<div class="c-gauge-circle" data-root>
                <div class="c-gauge-circle__chart" data-aria-element data-chart>
                    <div class="c-gauge-circle__chart-slice c-gauge-circle__chart-slice--one __chart-slice" data-sliceone></div>
                    <div class="c-gauge-circle__chart-slice c-gauge-circle__chart-slice--two __chart-slice" data-slicetwo></div>
                    <div class="c-gauge-circle__chart-center" data-chartcenter></div>
                </div>
                <label data-label class='c-gauge-circle__label'>
                    <span data-percentage class='c-gauge-circle__label-percentage'></span>
                    <span data-label-text></span>
                </label>
            </div>`,
            cacheDom: [ 'data-aria-element', 'data-chartcenter', 'data-sliceone', 'data-slicetwo', 'data-chart', 'data-label', 'data-percentage', 'data-label-text' ]
        };

        super(config);

        this._setAttributes();
    }

    static get validBackgrounds () {
        return [
            'white',
            'grey'
        ];
    }

    static get observedProps() {
        return [
            new wealthify.Prop('background', {
                default: 'white',
                validators: [wealthify.propValidators.IsInArray(this.validBackgrounds)]
            }),
            new wealthify.Prop('label'),
            new wealthify.Prop('loading', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('max', {
                default: 0,
                required: true,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('value', {
                default: 0,
                required: true,
                type: wealthify.propTypes.Number()
            })
        ];
    }

    get propCallbacks() {
        return {
            background: (value) => {
                this.constructor.validBackgrounds.forEach((colour) => this.dom.chartcenter.classList.remove(`${this.styleSelector}__chart-center--background-${colour}`));
                
                this.dom.chartcenter.classList.add(`${this.styleSelector}__chart-center--background-${value}`);
            },
            value: () => {
                this._updateCircle();
                this.dom.ariaElement.setAttribute('aria-valuenow', this.value);
            },
            label: (value) => {
                this.dom.labelText.innerHTML = value;
            },
            loading: () => this._toggleLoading(),
            max: () => {
                this._updateCircle();
                this.dom.ariaElement.setAttribute('aria-valuemax', this.max);
            }
        };
    }

    _setAttributes () {
        this.internalId = wealthify.type.number.getRandom();

        this.dom.label.setAttribute('id', `GaugeCircle_${this.internalId}_Label`);
        this.dom.ariaElement.setAttribute('aria-labelledby', `GaugeCircle_${this.internalId}_Label`);
    }

    _resetColourClasses(element) {
        for (var i = element.classList.length - 1; i >= 0; i--) {
            if (element.classList[i].indexOf('--colour-') > -1) {
                element.classList.remove(element.classList[i]);
            }
        }
    }

    _updateCircle() {
        this._resetColourClasses(this.dom['chart']);
        this._resetColourClasses(this.dom['sliceone']);
        this._resetColourClasses(this.dom['slicetwo']);

        if (this.max == null || !this.max > 0 || this.loading) {
            this._setDefaultCircle();

            return;
        }

        let percentComplete = Math.round((this.value / this.max) * 100);

        let gaugePercentage = percentComplete > 100 ? 100 : percentComplete;

        let degree = (gaugePercentage / 100 * 360);

        let deg1 = gaugePercentage <= 50 ? (gaugePercentage / 100 * 360 + 90) : 90;

        let deg2 = gaugePercentage <= 50 ? 0 : degree;

        this.dom['sliceone'].setAttribute('style', `transform: rotate(${deg1}deg);`);
        this.dom['slicetwo'].setAttribute('style', `transform: rotate(${deg2}deg);`);
        
        if (!this.loading) {
            this.dom.percentage.innerHTML = `${percentComplete}%`;
        }

        this._setColourClass();
    }

    _setDefaultCircle() {
        if (!this.loading){
            this.dom.percentage.innerHTML = '%';
        }
        
        this.dom['sliceone'].setAttribute('style', 'transform: rotate(90deg);');
        this.dom['slicetwo'].setAttribute('style', 'transform: rotate(0deg);');

        this._setColourClass(true);
    }

    _getColourClass(modifier = '', defaultColour = false) {
        let percentComplete = Math.round((this.max != null && this.max > 0) ?  (this.value / this.max) * 100 : 0);

        if (defaultColour) {
            return [`c-gauge-circle__chart${modifier}--colour-low-inverse`];
        }

        if (percentComplete <= 50) {
            return [`c-gauge-circle__chart${modifier}--colour-low-inverse`];
        } else if (percentComplete < 75) {
            return [`c-gauge-circle__chart${modifier}--colour-medium`];
        } else if (percentComplete <= 100) {
            return [`c-gauge-circle__chart${modifier}--colour-complete`];
        } else {
            return [`c-gauge-circle__chart${modifier}--colour-over`];
        }
    }

    _setColourClass(defaultColour = false) {
        var circleClassesToApply = this._getColourClass('', defaultColour);
        var sliceClassesToApply = this._getColourClass('-slice', defaultColour);

        this.dom['chart'].classList.add(...circleClassesToApply);
        this.dom['sliceone'].classList.add(...sliceClassesToApply);
        this.dom['slicetwo'].classList.add(...sliceClassesToApply);
    }

    _toggleLoading() {
        if (this.loading) {
            this._resetColourClasses(this.dom['chart']);
            this._resetColourClasses(this.dom['sliceone']);
            this._resetColourClasses(this.dom['slicetwo']);
            this._setDefaultCircle();

            this.dom.percentage.innerHTML = 'Loading...';
            this.dom.labelText.classList.add(`${this.styleSelector}--hidden`);
        } else {
            this.dom.labelText.classList.remove(`${this.styleSelector}--hidden`);
            this._updateCircle();
        }
    }
});